export const SOCIAL_AUTH_PROVIDER_GOOGLE = 2;